<template>
  <a-layout width="100%" style="min-width: 190px">
    <a-layout-content>
      <a-tree-select
        v-model:value="modalRef.selectedRows"
        size="small"
        style="min-width: 150px"
        :placeholder="field.placeholder"
        :disabled="field.disabled"
        :default-value="field.defaultValue"
        :allow-clear="field.allowClear"
        :tree-data="modalRef.datasource"
        :tree-checkable="field.multiple"
        :tree-node-filter-prop="field.valueKey"
        :tree-label-prop="field.labelKey"
        :dropdownStyle="{ maxHeight: '400px' }"
        @change="handleChange"
      />
    </a-layout-content>
    <a-layout-sider width="30px" style="background: rgba(0, 0, 0, 0)">
      <a-button size="small" style="width: 30px" @click="btnClick(true)" type="text">
        <template #icon>
          <reload-outlined />
        </template>
      </a-button>
    </a-layout-sider>
  </a-layout>
</template>

<script lang="ts">
import { defineComponent, reactive, watch } from 'vue';
import { RequestData } from '@/utils/hooks/useFetchData';
import getFormConfig from '@/components/FormRender/RemoteTreeSelect/index';
import { message } from 'ant-design-vue';

export default defineComponent({
  name: 'RemoteTreeSelect',
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, Number, String],
      required: false,
      default: () => null,
    },
    search_config: {
      type: Object,
      required: false,
      default: () => {},
    },
    label: {
      type: [Array, String],
      required: false,
    },
    formModel: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:value', 'update:label'],

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  setup(props: any, { emit }: any) {
    const modalRef = reactive({
      selectedRows: new Array<any>(),
      datasource: new Array<any>(),
    });
    const { searchConfig, getData } = getFormConfig(props.field.modalType);
    const search_modelRef = reactive({
      ...searchConfig.model,
    });

    if (props.value) {
      modalRef.selectedRows.push(props.value);
    }

    const getLabelFromDatasource = (datasource: Array<any>) => {
      const labelList: Array<string> = [];
      datasource.forEach((item: any) => {
        if (
          modalRef.selectedRows instanceof Array &&
          modalRef.selectedRows.includes(item[props.field.valueKey])
        ) {
          labelList.push(item[props.field.labelKey]);
        }
        if (
          !(modalRef.selectedRows instanceof Array) &&
          modalRef.selectedRows == item[props.field.valueKey]
        ) {
          labelList.push(item[props.field.labelKey]);
        }
        if (item.children && item.children.length > 0) {
          getLabelFromDatasource(item.children).forEach(obj => labelList.push(obj));
        }
      });
      return labelList;
    };

    const handleChange = () => {
      emit('update:value', modalRef.selectedRows);
      emit('update:label', getLabelFromDatasource(modalRef.datasource));
    };

    watch(
      () => props.formModel[props.field.name],
      () => {
        if (props.field.mode === 'default') {
          if (props.formModel[props.field.name]) {
            modalRef.selectedRows = [props.formModel[props.field.name]];
          } else {
            modalRef.selectedRows = [];
          }
        } else {
          //modalRef.selectedRows.length = 0;
          if (props.formModel[props.field.name] && props.formModel[props.field.name].length > 0) {
            modalRef.selectedRows = props.formModel[props.field.name].map((item: any) => {
              return item;
            });
          }
        }
        emit('update:label', getLabelFromDatasource(modalRef.datasource));
      },
    );

    const btnClick = (noCache?: boolean) => {
      if (noCache) {
        message.loading({ content: '刷新数据……', key: props.field.modalType });
      }

      getData({ ...search_modelRef, ...props.search_config }, noCache)
        .then(function (res: RequestData<any>) {
          modalRef.datasource = res.data;
          if (modalRef.datasource.length > 0 && modalRef.selectedRows.length > 0) {
            if (
              typeof modalRef.datasource[0][props.field.valueKey] == 'number' &&
              typeof modalRef.selectedRows[0] == 'string'
            ) {
              const list: Array<number> = [];
              modalRef.selectedRows.map((item: string) => {
                item.split(',').map(obj => {
                  list.push(Number(obj));
                });
              });
              if (props.field.multiple) {
                modalRef.selectedRows = list;
              } else {
                if (list.length > 1) {
                  list.length = 1;
                }
                modalRef.selectedRows = list;
              }
            }
          }
          emit('update:label', getLabelFromDatasource(modalRef.datasource));
          if (noCache) {
            message.success({ content: '刷新数据成功', key: props.field.modalType, duration: 2 });
          }
        })
        .catch(() => {
          message.destroy();
          message.error('接口调用失败', 10);
        });
    };
    btnClick();

    return {
      props,
      modalRef,
      search_modelRef,
      handleChange,
      btnClick,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
});
</script>
